// © Microsoft Corporation. All rights reserved.

// TODO: This should be considered for moving it to the Interests experience wrapper, once that
// code arrives, since this is specific to that experience

/**
 * Subnav TabId Enum object
 * @export
 * @type {enum}
 */
export enum SubnavTabId {
    None = 0,
    MyFeed = 1,
    XFeed = 2,
    Interests = 3
}
